
import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import useTranslation from '../../../Hooks/UseTranslation'
import { updateGroupNameAction } from '../../../Redux/Actions/ProgrammationManagerActions'

import InputText from '../components/InputText'
import { useProgrammation } from '../../../Hooks/UseProgrammation'
import { updateGroupName } from '@/Services/ProgrammationManagerService'
import { useProject } from '@/Hooks/UseProject'

const GroupName = () => {

  const dispatch = useDispatch()

  const { t } = useTranslation()

  const { project_id } = useProject()

  const { itemOpened, setEditingItem, patchItemOpened, errors, setError, unSetError } = useProgrammation()

  const [ name, setName ] = useState(itemOpened.name)

  const handleChangeName = async (newName?: string) => {
    if (!itemOpened) return

    const value = typeof newName === 'string' ? newName : name

    if (value === itemOpened.name) return

    setName(value)
    setEditingItem(true)
    unSetError('name')

    const [error] = await updateGroupName(itemOpened._id, value, project_id)

    setEditingItem(false)

    if (error) {
      setError({
        field: 'name',
        error: 'ocurrió un error al actualizar el nombre',
      })
      console.log('error', error)
      return false
    }

    patchItemOpened({ name: value })
    await dispatch(updateGroupNameAction(itemOpened._id, value, project_id))
  }

  return (
    <Form.Group>
      <Form.Label>
        {t('PROGRAMMATION_MANAGER:NameLabel')}
      </Form.Label>
      <InputText
        value={name}
        onChange={handleChangeName}
        // onStartEditing={() => setEditingItem(true)}
        placeholder="Ingresa el nombre"
        delay={500}
        error={errors.find((error: any) => error.field === 'name')}
      />
    </Form.Group>
  )
}

export default GroupName
